<script lang="ts">
	import Manufacturers from "@components/Manufacturers.svelte";
	import PageHero from "@components/PageHero.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import type { AboutProps } from "./AboutProps.js";

	const _: AboutProps = $props();
</script>

<Layout>
	<PageHero
		headline="O Intimexu"
		description="INTIMEX s. r. o. je mezinárodní společnost se sídlem v České republice, která byla založena v červnu 2002. Od svého vzniku se specializuje na dovoz a distribuci vysoce kvalitních diagnostických reagencií a laboratorního vybavení určeného pro pracoviště molekulární biologie, cytogenetiky a související vědecké obory."
		highlightedDescription="Díky dlouholetým zkušenostem a důrazu na kvalitu se INTIMEX s. r. o. řadí mezi spolehlivé partnery v oblasti laboratorní diagnostiky a biotechnologií."
	/>
	<Manufacturers />
</Layout>
